import { ReactElement, useState } from 'react'
import { useTranslation } from 'react-i18next'

import { useBalanceConfig } from '@features/balanceLedger'
import { BalanceFilterType } from '@features/balanceLedger/enums/balanceFilterType'
import { useUserOrganization } from '@modules-deprecated/app/organization'

import { useSuppliersBalanceFiltersContext } from '../../../../contexts/suppliersBalanceFiltersContext'
import { SuppliersBalanceFilterType } from '../../../../enums/suppliersBalanceFilterType'
import { useFetchCreditorBalanceSummaryAccounts } from '../../../../hooks/useFetchCreditorBalanceSummaryAccounts'
import { FilterChipShell } from '../../FilterChipShell'
import { AccountsFilterBody } from './AccountsFilterBody'
import { formatAccountsAnalyticsValue } from './formatAccountsAnalyticsValue'
import { formatAccountsPreview } from './formatAccountsPreview'

const TYPE = SuppliersBalanceFilterType.Account

type AccountsFilterChipProps = {
  encodedPeriod?: string
}

export const AccountsFilterChip = ({ encodedPeriod }: AccountsFilterChipProps): ReactElement => {
  const { filterTypeMeta } = useBalanceConfig()
  const { t } = useTranslation()
  const { organization } = useUserOrganization()
  const { filters, setFilterValue, removeFilter, resetFilter } = useSuppliersBalanceFiltersContext()
  const selectedIds = filters.account ?? []
  const [isDropdownOpen, setIsDropdownOpen] = useState(false)
  const meta = filterTypeMeta[BalanceFilterType.Account]

  const { accounts } = useFetchCreditorBalanceSummaryAccounts({
    organizationId: organization?.id ?? '',
    period: encodedPeriod,
    enabled: isDropdownOpen || selectedIds.length > 0,
  })

  return (
    <FilterChipShell
      type={TYPE}
      icon={meta.icon}
      label={t(meta.labelKey)}
      valuePreview={formatAccountsPreview(selectedIds, accounts)}
      valueCount={selectedIds.length || undefined}
      isActive={selectedIds.length > 0}
      onDelete={() => removeFilter(TYPE)}
      onReset={() => resetFilter(TYPE)}
      onOpen={() => setIsDropdownOpen(true)}
      onClose={() => setIsDropdownOpen(false)}
    >
      <AccountsFilterBody
        selectedIds={selectedIds}
        onChange={(ids) => setFilterValue(TYPE, ids, formatAccountsAnalyticsValue(ids, accounts))}
        encodedPeriod={encodedPeriod}
        enabled={isDropdownOpen}
      />
    </FilterChipShell>
  )
}
